export default __webpack_public_path__ + "static/media/ergocare.822ff1c4.jpg";